export function getIp(request) {
    if (process.env && process.env.BEHIND_CLOUDFLARE) {
        return request.headers['cf-connecting-ip'];
    }
    return request.ip;
}
// Preferred over geoip-lite, which is stale between deploys and worst on exactly
// the datacenter/VPN ranges people test with. 'XX' (ungeolocatable) and 'T1'
// (Tor) are not countries.
export function getCountryFromEdge(request) {
    const country = request.headers && request.headers['cf-ipcountry'];
    if (!country || !/^[A-Za-z]{2}$/.test(country)) {
        return null;
    }
    const normalized = country.toUpperCase();
    return normalized === 'XX' || normalized === 'T1' ? null : country;
}
